export const distributionCenterOptions = [
  { value: 1, label: "Piedade", text: "Piedade", color: "#3E4F89" }
];

export const findDistributionCenter = value => {
  return distributionCenterOptions.find(cd => cd.value === value);
};
